<template>
  <cards class="mb-20 mt-15">
    <information />
    <password />
    <two-factor />
    <account />
  </cards>
</template>

<script lang="ts" setup>
import Cards from '@components/utils/Cards.vue';
import Information from '@pages/profile/Information.vue';
import Password from '@pages/profile/Password.vue';
import TwoFactor from '@pages/profile/TwoFactor.vue';
import Account from '@pages/profile/Account.vue';
</script>

<style lang="scss" scoped>
</style>
